<template>
  <v-app>
    <router-view></router-view>
    <v-snackbar v-model="snack.visible" :timeout="3000" :color="snack.color">
      {{ snack.text }}
      <v-btn text @click="snack.visible = false">Закрыть</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      snack: {
        visible: false,
        color: "blue",
        text: ""
      }
    };
  },
  mounted() {
    this.$root.$on("notify", this.onNotify);
  },

  destroyed() {
    this.$root.$off("notify", this.onNotify);
  },

  methods: {
    onNotify(text, color) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.visible = true;
    }
  }
};
</script>
